export default __webpack_public_path__ + "static/media/icon-geolocalisation.7a43a805.svg";